import ListVehicles from '@/views/vehicles/ListVehicles.vue'
import GetVehicle from '@/views/vehicles/GetVehicle.vue'

export default [
	{
		name: 'list-vehicles',
		path: '/',
		component: ListVehicles,
	},
	{
		name: 'get-vehicle',
		path: '/vehicles/:id',
		component: GetVehicle, meta: { back: () => ({ name: 'list-vehicles' }) },
	},
]